<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <div class="container-fluid">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="dialogRef.close()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Origen del servicio
        </h4>
        <div class="row" *ngIf="canSeeOriginLoadService">
            <div class="col-12 mb-3 geo-map-wrapper" *ngIf="!isInternationalControl.value && originControl.value?.id">
                <div class="geo-map-header">
                    <span class="geo-map-title">
                        <i class="fas fa-map-marked-alt mr-2"></i>Mapa de origen
                    </span>
                    <button type="button" class="geo-map-toggle" (click)="toggleOriginMap()">
                        <i class="fas" [ngClass]="showOriginMap ? 'fa-eye-slash' : 'fa-eye'"></i>
                        <span>{{ showOriginMap ? 'Ocultar mapa' : 'Mostrar mapa' }}</span>
                    </button>
                </div>
                <div class="geo-map-body" *ngIf="showOriginMap">
                    <app-standard-map (mapReady)="onMapReady()"></app-standard-map>
                </div>
            </div>
            <p class="col-12 my-3 text-bold">
                Origen
            </p>
            <app-autocomplete-city [inputFormControl]="originControl" [options]="originCityOptions"
                [validate]="originControl.disabled ? 'disable' : formValidate"
                [ngClass]="{'col-md-6': !isInternationalTrip, 'col-md-12': isInternationalTrip}">
            </app-autocomplete-city>
            <div class="col-md-6 pb-3 pb-md-0" *ngIf="isInternationalTrip">
                <label class="text-strong">¿Es Internacional?&nbsp;&nbsp;</label>
                <mat-button-toggle-group [formControl]="isInternationalControl" #group="matButtonToggleGroup">
                    <mat-button-toggle [value]="true" (change)="onChangeInternational()">
                        Si
                    </mat-button-toggle>
                    <mat-button-toggle [value]="false" (change)="onChangeInternational()">
                        No
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>
                    Fecha estimada {{menuService?.isTransportService() ? 'de cargue' : 'de llegada'}}
                    <span class="asterisk">*</span>
                </mat-label>
                <input matInput [min]="menuService?.isTransportService() ? loadDateOptions.min : null"
                    [matDatepicker]="pickerLoadDate" [formControl]="loadDateControl" name="loadDate"
                    (click)="pickerLoadDate.open()" readonly
                    [max]="menuService?.isTransportService() ? loadDateOptions.max : null">
                <mat-datepicker-toggle matSuffix [for]="pickerLoadDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerLoadDate></mat-datepicker>
                <mat-error *ngIf="loadDateControl.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>

            <div class="alert alert-warning col-12 text-center" role="alert" *ngIf="showErrorReteica">
                <i class="fas fa-exclamation-circle mr-3"></i>
                {{reteicaError}}
            </div>
            <p class="col-12 my-3 text-bold">
                Direcciones
            </p>
            <div class="col-12 row align-items-baseline" *ngFor="let address of originAddresses.controls; let i=index">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <p class="mb-2 text-bold">Direccion {{i + 1}}</p>
                    <i class="fas fa-times cursor-pointer" matTooltip="Eliminar dirección"
                        *ngIf="i && canEditOriginLoadService && address.get('address').enabled && (!isDialog || !menuService?.cargo?.ministry)"
                        (click)="removeSenderAddress(i)"></i>
                </div>
                <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>Hora estimada <span class="asterisk">*</span></mat-label>
                    <input matInput [formControl]="address.get('time')" type="time">
                    <mat-error *ngIf="address.get('time').errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-6" *ngIf="menuService.isTransportService()">
                    <mat-label>
                        Celular de contacto
                        <span class="optional">(opcional)</span>
                    </mat-label>
                    <input matInput onlyNumbersInt type="tel" [formControl]="address.get('cellphone')">
                    <mat-error *ngIf="address.get('cellphone').errors?.minlength">
                        {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'celular', 10) }}
                    </mat-error>
                </mat-form-field>
                <mat-checkbox [formControl]="address.get('hasThirdParty')"
                    class="col-md-6 pb-3 text-bold align-self-end"
                    *ngIf="menuService.isTransportService() && menuService.isMinistryService() && !isInternationalControl.value">
                    <span class="text-wrap-balance">Esta dirección va incluida en la remesa</span>
                </mat-checkbox>
                <app-autocomplete-address
                    *ngIf="menuService.isTransportService() && !address.get('hasThirdParty').value"
                    class="col-md-12 mb-3" [options]="{
                        title: originAddressOptions.title,
                        appearance: originAddressOptions.appearance,
                        initialValue: initialAddresses[i]?.initialValue,
                        internationalCode: originControl.value?.code,
                        municipalityCode: originControl?.value?.id,
                        showHintRequiredAddressSelection: true,
                        selectAddressOnMap: true,
                        correctAddress: true
                    }" [inputFormControl]="address.get('address')"
                    [validate]="address.get('address').disabled ? 'disable' : formValidate">
                </app-autocomplete-address>
                <app-geo-validation-feedback class="col-12"
                    *ngIf="menuService.isTransportService() && !address.get('hasThirdParty').value && !isInternationalControl.value"
                    [validating]="address.get('address').pending"
                    [error]="address.get('address').errors?.outsideMunicipality">
                </app-geo-validation-feedback>
                <!-- Third party -->
                <ng-container *ngIf="!menuService.isTransportService() || address.get('hasThirdParty').value">
                    <app-autocomplete-thirdparty class="col-md-6" [options]="{
                            title: 'Remitente',
                            appearance: 'outline',
                            initialValue: initialAddresses[i]?.initialThirdParty
                        }" [inputFormControl]="address.get('thirdParty')"
                        [validate]="address.get('address').disabled ? 'disable' : formValidate">
                    </app-autocomplete-thirdparty>
                    <app-autocomplete-thirdparty-address [inputFormControl]="address.get('thirdPartyAddress')"
                        class="col-12" [validate]="address.get('address').disabled ? 'disable' : formValidate"
                        [options]="{
                            title: 'Dirección de remitente',
                            appearance: 'outline',
                            companyId: address.get('thirdParty').value?.document,
                            municipalityCode: originControl?.value?.id,
                            thirdParty: address.get('thirdParty').value,
                            initialValue: initialAddresses[i]?.initialValue,
                            showEditAddress: !isDialog
                        }" (emitToParent)="saveAndContinue(true)">
                    </app-autocomplete-thirdparty-address>
                    <app-geo-validation-feedback class="col-12"
                        *ngIf="!isInternationalControl.value"
                        [validating]="address.get('thirdPartyAddress').pending"
                        [error]="address.get('thirdPartyAddress').errors?.outsideMunicipality">
                    </app-geo-validation-feedback>
                    <div *ngIf="address?.get('thirdPartyAddress')?.value && address?.get('thirdPartyAddress')?.value?.information?.document !== address?.get('thirdParty')?.value?.document"
                        class="alert alert-warning col-12" role="alert">
                        La dirección de remitente no coincide con el remitente
                    </div>
                </ng-container>
            </div>
            <p class="text-bold font-secondary-dark pl-2 cursor-pointer" (click)="addAddressForm()"
                *ngIf="canEditOriginLoadService && (!isDialog || !menuService?.cargo?.ministry)">
                <i class="fas fa-plus-circle"></i>
                <span>Agregar otra dirección</span>
            </p>
            <p class="col-12 alert alert-info text-bold text-center" role="alert"
                *ngIf="canEditOriginLoadService && isDialog">
                <i class="fas fa-info-circle"></i>
                <span>
                    Si realiza un cambio en la ciudad de origen, recuerde actualizar sus direcciones
                </span>
                <br *ngIf="menuService?.cargo?.ministry">
                <span *ngIf="menuService?.cargo?.ministry">
                    Si realiza un cambio en la fecha de cargue, recuerde actualizar las remesas asociadas a este
                    servicio
                </span>
            </p>
        </div>
        <div *ngIf="!canSeeOriginLoadService" class="no-permission-container">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <h4 class="text-bold">No tienes permiso para acceder a esta información. Contacta a tu administrador para
                solicitar acceso.</h4>
        </div>
        <div class="button-container mt-4" *ngIf="!isDialog; else dialogButtons">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button type="submit" class="mx-2" mat-raised-button color="accent" *ngIf="canEditOriginLoadService">
                Guardar y Continuar
            </button>
            <button type="button" class="mx-2" mat-raised-button color="accent" *ngIf="!canEditOriginLoadService"
                (click)="continueToNextStep()">
                Continuar
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="submit" mat-raised-button color="accent">
                    Guardar
                </button>
            </div>
        </ng-template>
    </div>
</form>